import React from 'react';
import {Header, Checkbox} from 'semantic-ui-react';
import SectionCaption from './SectionCaption';

// eslint-disable-next-line max-len
const Subheader = ({title, subtitle, text, sectionReview, sectionReviewName, handleSelect, scopePermission, showCheck, showVehicleName, showVehicle}) => {
  return (
    <div className="tcc-wrapper">
      <Header as="h2">
        {title}
        <SectionCaption text={text} />
        {scopePermission && (

          <Checkbox
            onChange={(e, {checked}) => handleSelect(e, sectionReviewName, checked)}
            checked={sectionReview}
            name={sectionReviewName}
            label="Sección revisada"
          />
        )}
        {
          showCheck && <Checkbox
            style={{'marginLeft': '10px'}}
            onChange={(e, {checked}) => handleSelect(e, showVehicleName, checked)}
            checked={showVehicle}
            name={showVehicleName}
            label="Mostrar Vehiculo en la página web"
          />
        }
      </Header>
      <p>{subtitle}</p>
    </div>
  );
};

export default Subheader;
